import React from "react";
import { Heading } from "../shared/Heading";
import { useContext } from "../../../../../context";
import { QuestionBox } from "../shared/QuestionBox";
import { ImageUploader } from "../../../../../../../../../boxes/ImageUploader/ImageUploader";
import { useAppTranslation } from "../../../../../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../../../../../services/UINotificationService";
import { fileUtil } from "../../../../../../../../../utilities/file";
import { BLOCK_FIELDS } from "../../../../../config";

export const File = () => {
  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "survey.preview",
  });

  const { blocks, previewAnswers } = useContext();
  const block = blocks.getCurrent();

  const handleChange = async (e) => {
    const raw = e.target?.files?.[0];

    if (!raw) {
      return;
    }

    if (!raw.type.includes("image/")) {
      uiNotification.error(t("error.fileType"));
      return;
    }

    previewAnswers.set(
      block.id,
      await fileUtil.read(raw, { method: "dataUrl" }),
    );
  };

  return (
    <QuestionBox>
      <Heading
        title={block[BLOCK_FIELDS.question]}
        description={block[BLOCK_FIELDS.description]}
        index={blocks.getCurrentIndex() + 1}
      />
      <ImageUploader
        name="answerFile"
        value={previewAnswers.get(block.id) || ""}
        onRemove={() => previewAnswers.set(block.id, "")}
        onChange={handleChange}
      />
    </QuestionBox>
  );
};
